'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var gqlUtils = require('@liquorice/gql-utils');
var material = require('@mui/material');
var FIELD_FRAGMENT = require('../../gql/fragments/FIELD_FRAGMENT.js');
var useFieldConditions = require('../../lib/useFieldConditions.js');
var withErrorBoundary = require('../ErrorBoundary/withErrorBoundary.js');
var Field_Address = require('../Field_Address.js');
var Field_AddressCountry = require('../Field_AddressCountry.js');
var Field_Agree = require('../Field_Agree.js');
var Field_Checkboxes = require('../Field_Checkboxes.js');
var Field_Date = require('../Field_Date.js');
var Field_Dropdown = require('../Field_Dropdown.js');
var Field_FileUpload = require('../Field_FileUpload.js');
var Field_Heading = require('../Field_Heading.js');
var Field_Name = require('../Field_Name.js');
var Field_NamePrefix = require('../Field_NamePrefix.js');
var Field_Radio = require('../Field_Radio.js');
var Field_Section = require('../Field_Section.js');
var Field_Text = require('../Field_Text.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FormieField = withErrorBoundary(gqlUtils.withFragment(FIELD_FRAGMENT.FIELD_FRAGMENT, (field, { methods, parentHandle })=>{
    const show = useFieldConditions(field, methods);
    if (show === false) {
        return null;
    }
    if (!field) return null;
    field = _extends({}, field, {
        // Append the parent handle if we have one
        handle: parentHandle ? `${parentHandle}.${field.handle}` : field.handle
    });
    // Calculate any conditions
    // TODO: Implement conditions
    // const conditionalShow = useFormFieldCondition(field.conditions, field.enableConditions);
    const boxProps = {};
    const boxStyle = {
        flexGrow: 1,
        flexBasis: 100
    };
    let inner = null;
    switch(field.__typename){
        case 'Field_Heading':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Heading.Field_Heading, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_Section':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Section.Field_Section, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_Address':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Address.Field_Address, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_Name':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Name.Field_Name, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_Agree':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Agree.Field_Agree, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_NamePrefix':
            boxStyle.width = 100;
            boxStyle.flexGrow = 0;
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_NamePrefix.Field_NamePrefix, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_AddressCountry':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_AddressCountry.Field_AddressCountry, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_Date':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Date, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_Dropdown':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Dropdown.Field_Dropdown, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_Checkboxes':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Checkboxes.Field_Checkboxes, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_Radio':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Radio.Field_Radio, {
                field: field,
                methods: methods
            });
            break;
        case 'Field_FileUpload':
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_FileUpload.Field_FileUpload, {
                field: field,
                methods: methods
            });
            break;
        default:
            inner = /*#__PURE__*/ jsxRuntime.jsx(Field_Text.Field_Text, {
                data: field,
                methods: methods
            });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(material.Box, _extends({}, boxProps, {
        sx: boxStyle,
        children: inner
    }));
}));

module.exports = FormieField;
